import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

// Alle zondagen van een jaar (week start op zondag = start nachtdienst)
function zondagenVanJaar(jaar) {
  const out = [];
  const d = new Date(jaar, 0, 1);
  d.setDate(d.getDate() + ((7 - d.getDay()) % 7));
  while (d.getFullYear() === jaar) { out.push(new Date(d)); d.setDate(d.getDate() + 7); }
  return out;
}
function toStr(d) {
  return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
}
function weekNr(d) {
  const t = new Date(d); t.setHours(0,0,0,0);
  t.setDate(t.getDate() + 3 - ((t.getDay() + 6) % 7));
  const w1 = new Date(t.getFullYear(), 0, 4);
  return 1 + Math.round(((t - w1) / 86400000 - 3 + ((w1.getDay() + 6) % 7)) / 7);
}

function heeftDienst(m, weekStart, startVeld, intervalVeld) {
  if (!m[startVeld] || !m[intervalVeld]) return false;
  const start = new Date(m[startVeld]);
  const diffWeken = Math.floor((weekStart - start) / (7 * 24 * 60 * 60 * 1000));
  return diffWeken >= 0 && diffWeken % m[intervalVeld] === 0;
}

const MonteurKoppels = () => {
  const { gebruiker } = useAuth();
  const [jaar, setJaar] = useState(new Date().getFullYear());
  const [monteurs, setMonteurs] = useState([]);
  const [koppels, setKoppels] = useState({});   // weekStr -> [teams]
  const [busy, setBusy] = useState(false);
  const [nieuwWeek, setNieuwWeek] = useState(null);   // weekStr waar "+team" open staat
  const [nieuwLeden, setNieuwLeden] = useState([]);
  const vandaag = new Date();

  const laad = useCallback(async () => {
    try {
      const [gRes, kRes] = await Promise.all([
        api.get('/gebruikers'),
        api.get('/monteur-koppels?jaar=' + jaar + '&afdeling_id=' + gebruiker.afdeling_id),
      ]);
      const gebruikers = gRes.data.gebruikers || gRes.data || [];
      setMonteurs(gebruikers.filter(g => g.afdeling_id === gebruiker.afdeling_id && g.actief !== false));
      const map = {};
      (kRes.data.koppels || []).forEach(k => {
        const w = String(k.week_start).slice(0,10);
        (map[w] = map[w] || []).push(k);
      });
      setKoppels(map);
    } catch (e) { console.error(e); }
  }, [jaar, gebruiker?.afdeling_id]);

  useEffect(() => { if (gebruiker?.afdeling_id) laad(); }, [laad, gebruiker?.afdeling_id]);

  const naamVan = (id) => {
    const m = monteurs.find(x => x.id === id);
    if (!m) return '#' + id;
    return m.voornaam ? (m.voornaam + ' ' + (m.achternaam || '')).trim() : m.gebruikersnaam;
  };

  const teamOpslaan = async (weekStr) => {
    if (nieuwLeden.length < 2) { alert('Minimaal 2 monteurs'); return; }
    setBusy(true);
    try {
      await api.post('/monteur-koppels', { week_start: weekStr, afdeling_id: gebruiker.afdeling_id, leden: nieuwLeden });
      setNieuwWeek(null); setNieuwLeden([]);
      await laad();
    } catch (e) { alert('Opslaan mislukt'); }
    setBusy(false);
  };

  const lidToevoegen = async (team, id) => {
    setBusy(true);
    try {
      await api.post('/monteur-koppels', { id: team.id, leden: [...team.leden, id] });
      await laad();
    } catch (e) { alert('Opslaan mislukt'); }
    setBusy(false);
  };

  const lidWeghalen = async (team, id) => {
    const rest = team.leden.filter(l => l !== id);
    setBusy(true);
    try {
      if (rest.length < 2) await api.delete('/monteur-koppels/' + team.id);
      else await api.post('/monteur-koppels', { id: team.id, leden: rest });
      await laad();
    } catch (e) { alert('Opslaan mislukt'); }
    setBusy(false);
  };

  const teamVerwijderen = async (team) => {
    setBusy(true);
    try { await api.delete('/monteur-koppels/' + team.id); await laad(); }
    catch (e) { alert('Verwijderen mislukt'); }
    setBusy(false);
  };

  const weken = zondagenVanJaar(jaar);
  const chip = { display: 'inline-flex', alignItems: 'center', gap: 4, background: '#dbeafe', color: '#1e40af',
    padding: '2px 8px', borderRadius: 12, fontSize: 13, marginRight: 6 };
  const sel = { padding: '4px 8px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13 };

  return (
    <div style={{ padding: 24, maxWidth: 950 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 6 }}>
        <h2 style={{ margin: 0 }}>{'\uD83D\uDD17'} Monteur-teams per week</h2>
        <select value={jaar} onChange={e => setJaar(Number(e.target.value))} style={sel}>
          {[jaar-1, jaar, jaar+1].filter((v,i,a) => a.indexOf(v) === i).map(j => <option key={j} value={j}>{j}</option>)}
        </select>
      </div>
      <p style={{ color: '#6b7280', marginTop: 0 }}>
        Stel per week teams samen (2 of meer monteurs). Week start op zondag. Doorplannen en de vrijdag-herplanning
        zetten werk op het hele team; bij meerdere teams wint het minst belaste team. Geen team = verdeling over minst belaste monteurs.
      </p>
      <table style={{ borderCollapse: 'collapse', width: '100%', background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <thead>
          <tr style={{ background: '#f3f4f6', textAlign: 'left' }}>
            <th style={{ padding: '8px 12px', width: 90 }}>Week</th>
            <th style={{ padding: '8px 12px', width: 110 }}>Zondag</th>
            <th style={{ padding: '8px 12px' }}>Teams</th>
          </tr>
        </thead>
        <tbody>
          {weken.map(zo => {
            const weekStr = toStr(zo);
            const teams = koppels[weekStr] || [];
            const isHuidig = vandaag >= zo && vandaag < new Date(zo.getTime() + 7*86400000);
            const isVerleden = zo < vandaag && !isHuidig;
            const beschikbaarNieuw = monteurs.filter(m => !nieuwLeden.includes(m.id));
            return (
              <tr key={weekStr} style={{ borderTop: '1px solid #e5e7eb',
                background: isHuidig ? '#ecfdf5' : teams.length ? '#f8fafc' : 'transparent',
                opacity: isVerleden ? 0.55 : 1 }}>
                <td style={{ padding: '6px 12px', fontWeight: isHuidig ? 700 : 500, verticalAlign: 'top' }}>
                  {weekNr(new Date(zo.getTime() + 86400000))}{isHuidig ? ' \u2190 nu' : ''}
                </td>
                <td style={{ padding: '6px 12px', color: '#6b7280', verticalAlign: 'top' }}>{weekStr}</td>
                <td style={{ padding: '6px 12px' }}>
                  {(() => {
                    const nacht = monteurs.filter(m => heeftDienst(m, zo, 'nachtdienst_start', 'nachtdienst_interval_weken'));
                    const wacht = monteurs.filter(m => heeftDienst(m, zo, 'storingsdienst_start', 'storingsdienst_interval_weken'));
                    if (!nacht.length && !wacht.length) return null;
                    return (
                      <div style={{ fontSize: 12.5, color: '#6b7280', marginBottom: 6 }}>
                        {nacht.length > 0 && <span>{'\uD83C\uDF19'} {nacht.map(m => naamVan(m.id)).join(', ')}</span>}
                        {nacht.length > 0 && wacht.length > 0 && <span> {'\u00B7'} </span>}
                        {wacht.length > 0 && <span>{'\uD83D\uDD34'} {wacht.map(m => naamVan(m.id)).join(', ')}</span>}
                      </div>
                    );
                  })()}
                  {teams.map(team => (
                    <div key={team.id} style={{ marginBottom: 6, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
                      {(team.leden || []).map(id => (
                        <span key={id} style={chip}>
                          {naamVan(id)}
                          <span onClick={() => !busy && lidWeghalen(team, id)}
                            style={{ cursor: 'pointer', fontWeight: 700, marginLeft: 2 }} title="Uit team halen">×</span>
                        </span>
                      ))}
                      <select style={sel} disabled={busy} value=""
                        onChange={e => e.target.value && lidToevoegen(team, Number(e.target.value))}>
                        <option value="">+ monteur</option>
                        {monteurs.filter(m => !(team.leden || []).includes(m.id)).map(m => (
                          <option key={m.id} value={m.id}>{naamVan(m.id)}</option>
                        ))}
                      </select>
                      <span onClick={() => !busy && teamVerwijderen(team)}
                        style={{ cursor: 'pointer', color: '#ef4444', fontSize: 13, marginLeft: 4 }} title="Team verwijderen">🗑</span>
                    </div>
                  ))}
                  {nieuwWeek === weekStr ? (
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
                      {nieuwLeden.map(id => (
                        <span key={id} style={chip}>
                          {naamVan(id)}
                          <span onClick={() => setNieuwLeden(nieuwLeden.filter(l => l !== id))}
                            style={{ cursor: 'pointer', fontWeight: 700, marginLeft: 2 }}>×</span>
                        </span>
                      ))}
                      <select style={sel} value="" disabled={busy}
                        onChange={e => e.target.value && setNieuwLeden([...nieuwLeden, Number(e.target.value)])}>
                        <option value="">+ monteur</option>
                        {beschikbaarNieuw.map(m => <option key={m.id} value={m.id}>{naamVan(m.id)}</option>)}
                      </select>
                      <button onClick={() => teamOpslaan(weekStr)} disabled={busy || nieuwLeden.length < 2}
                        style={{ padding: '3px 10px', borderRadius: 6, border: 'none', background: '#10b981', color: '#fff', cursor: 'pointer', fontSize: 13 }}>
                        Opslaan
                      </button>
                      <button onClick={() => { setNieuwWeek(null); setNieuwLeden([]); }}
                        style={{ padding: '3px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
                        Annuleer
                      </button>
                    </div>
                  ) : (
                    <span onClick={() => { setNieuwWeek(weekStr); setNieuwLeden([]); }}
                      style={{ cursor: 'pointer', color: '#3b82f6', fontSize: 13 }}>＋ team toevoegen</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MonteurKoppels;
